// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ADJUDICATION_TALENT: {
    id: 1277005,
    name: 'Adjudication',
    icon: 'inv_mace_2h_draenorraid_d_03',
    maxRanks: 1,
    entryIds: [136732],
    definitionIds: [{ id: 141504, specId: 66 }],
  },
  AFTERIMAGE_TALENT: {
    id: 385414,
    name: 'Afterimage',
    icon: 'spell_holy_aspiration',
    maxRanks: 1,
    entryIds: [102601, 115480, 115482],
    definitionIds: [
      { id: 107606, specId: 65 },
      { id: 120492, specId: 66 },
      { id: 120494, specId: 70 },
    ],
  },
  ARDENT_DEFENDER_TALENT: {
    id: 31850,
    name: 'Ardent Defender',
    icon: 'spell_holy_ardentdefender',
    maxRanks: 1,
    entryIds: [102445],
    definitionIds: [{ id: 107450, specId: 66 }],
  },
  ARMORY_OF_LIGHT_TALENT: {
    id: 1277443,
    name: 'Armory of Light',
    icon: 'inv12_ability_paladin_sentinel',
    maxRanks: 1,
    entryIds: [136593],
    definitionIds: [{ id: 141366, specId: 65 }],
  },
  ART_OF_WAR_TALENT: {
    id: 406064,
    name: 'Art of War',
    icon: 'ability_paladin_artofwar',
    maxRanks: 1,
    entryIds: [102493],
    definitionIds: [{ id: 107498, specId: 70 }],
  },
  AURAS_OF_THE_RESOLUTE_TALENT: {
    id: 385633,
    name: 'Auras of the Resolute',
    icon: 'spell_holy_devotionaura',
    maxRanks: 1,
    entryIds: [102587],
    definitionIds: [{ id: 107592, specId: 70 }],
  },
  AURA_MASTERY_TALENT: {
    id: 31821,
    name: 'Aura Mastery',
    icon: 'spell_holy_auramastery',
    maxRanks: 1,
    entryIds: [102548],
    definitionIds: [{ id: 107553, specId: 65 }],
  },
  AURORA_TALENT: {
    id: 439760,
    name: 'Aurora',
    icon: 'spell_holy_rune',
    maxRanks: 1,
    entryIds: [117666],
    definitionIds: [{ id: 122678, specId: 70 }],
  },
  AUTHORITATIVE_REBUKE_TALENT: {
    id: 469886,
    name: 'Authoritative Rebuke',
    icon: 'inv_misc_symbolofkings_01',
    maxRanks: 1,
    entryIds: [117879],
    definitionIds: [{ id: 122891, specId: 66 }],
  },
  AVENGERS_SHIELD_TALENT: {
    id: 31935,
    name: "Avenger's Shield",
    icon: 'spell_holy_avengersshield',
    maxRanks: 1,
    entryIds: [102471],
    definitionIds: [{ id: 107476, specId: 66 }],
  },
  AVENGING_CRUSADER_TALENT: {
    id: 394088,
    name: 'Avenging Crusader',
    icon: 'ability_paladin_veneration',
    maxRanks: 1,
    entryIds: [102568],
    definitionIds: [{ id: 107573, specId: 65 }],
  },
  AVENGING_WRATH_TALENT: {
    id: 31884,
    name: 'Avenging Wrath',
    icon: 'spell_holy_avenginewrath',
    maxRanks: 1,
    entryIds: [102569, 102448, 102519],
    definitionIds: [
      { id: 107574, specId: 65 },
      { id: 107453, specId: 66 },
      { id: 107524, specId: 70 },
    ],
  },
  AWAKENING_TALENT: {
    id: 414195,
    name: 'Awakening',
    icon: 'inv_helm_plate_raidpaladin_n_01',
    maxRanks: 1,
    entryIds: [116205],
    definitionIds: [{ id: 121217, specId: 65 }],
  },
  AWESTRUCK_TALENT: {
    id: 417855,
    name: 'Awestruck',
    icon: 'ability_paladin_blindinglight2',
    maxRanks: 1,
    entryIds: [102544],
    definitionIds: [{ id: 107549, specId: 65 }],
  },
  A_JUST_REWARD_TALENT: {
    id: 469411,
    name: 'A Just Reward',
    icon: 'spell_holy_blindingheal',
    maxRanks: 2,
    entryIds: [128254],
    definitionIds: [{ id: 133061, specId: 70 }],
  },
  BEACON_OF_FAITH_TALENT: {
    id: 156910,
    name: 'Beacon of Faith',
    icon: 'ability_paladin_beaconsoflight',
    maxRanks: 1,
    entryIds: [102533],
    definitionIds: [{ id: 107538, specId: 65 }],
  },
  BEACON_OF_THE_LIGHTBRINGER_TALENT: {
    id: 197446,
    name: 'Beacon of the Lightbringer',
    icon: 'spell_paladin_clarityofpurpose',
    maxRanks: 1,
    entryIds: [102549],
    definitionIds: [{ id: 107554, specId: 65 }],
  },
  BEACON_OF_THE_SAVIOR_1_HOLY_TALENT: {
    id: 1244878,
    name: 'Beacon of the Savior',
    icon: 'inv12_apextalent_paladin_beaconofthesavior',
    maxRanks: 1,
    entryIds: [137019],
    definitionIds: [{ id: 141782, specId: 65 }],
  },
  BEACON_OF_THE_SAVIOR_2_HOLY_TALENT: {
    id: 1245367,
    name: 'Beacon of the Savior',
    icon: 'inv12_apextalent_paladin_beaconofthesavior',
    maxRanks: 2,
    entryIds: [137018],
    definitionIds: [{ id: 141781, specId: 65 }],
  },
  BEACON_OF_THE_SAVIOR_3_HOLY_TALENT: {
    id: 1245368,
    name: 'Beacon of the Savior',
    icon: 'inv12_apextalent_paladin_beaconofthesavior',
    maxRanks: 1,
    entryIds: [137017],
    definitionIds: [{ id: 141780, specId: 65 }],
  },
  BEACON_OF_VIRTUE_TALENT: {
    id: 200025,
    name: 'Beacon of Virtue',
    icon: 'ability_paladin_beaconofinsight',
    maxRanks: 1,
    entryIds: [102532],
    definitionIds: [{ id: 107537, specId: 65 }],
    manaCost: 11250,
  },
  BESTOW_LIGHT_TALENT: {
    id: 448040,
    name: 'Bestow Light',
    icon: 'ability_paladin_sheathoflight',
    maxRanks: 1,
    entryIds: [102539],
    definitionIds: [{ id: 107544, specId: 65 }],
  },
  BLADES_OF_LIGHT_TALENT: {
    id: 403664,
    name: 'Blades of Light',
    icon: 'achievement_arena_3v3_7',
    maxRanks: 2,
    entryIds: [115443],
    definitionIds: [{ id: 120455, specId: 70 }],
  },
  BLADE_OF_JUSTICE_TALENT: {
    id: 184575,
    name: 'Blade of Justice',
    icon: 'ability_paladin_bladeofjustice',
    maxRanks: 1,
    entryIds: [102498],
    definitionIds: [{ id: 107503, specId: 70 }],
  },
  BLADE_OF_VENGEANCE_TALENT: {
    id: 403826,
    name: 'Blade of Vengeance',
    icon: 'ability_paladin_bladeofjustice',
    maxRanks: 1,
    entryIds: [102521],
    definitionIds: [{ id: 107526, specId: 70 }],
  },
  BLESSED_ASSURANCE_TALENT: {
    id: 433015,
    name: 'Blessed Assurance',
    icon: 'spell_holy_blessedlife',
    maxRanks: 1,
    entryIds: [117883],
    definitionIds: [{ id: 122895, specId: 66 }],
  },
  BLESSED_CALLING_TALENT: {
    id: 469770,
    name: 'Blessed Calling',
    icon: 'ability_paladin_judgementofthepure',
    maxRanks: 1,
    entryIds: [128264],
    definitionIds: [{ id: 133071, specId: 70 }],
  },
  BLESSED_CHAMPION_TALENT: {
    id: 403010,
    name: 'Blessed Champion',
    icon: 'achievement_bg_trueavshutout',
    maxRanks: 1,
    entryIds: [102515],
    definitionIds: [{ id: 107520, specId: 70 }],
  },
  BLESSED_HAMMER_TALENT: {
    id: 204019,
    name: 'Blessed Hammer',
    icon: 'paladin_retribution',
    maxRanks: 1,
    entryIds: [102430],
    definitionIds: [{ id: 107435, specId: 66 }],
  },
  BLESSING_OF_ANSHE_TALENT: {
    id: 445200,
    name: "Blessing of An'she",
    icon: 'inv_ability_holyfire_orb',
    maxRanks: 1,
    entryIds: [117668],
    definitionIds: [{ id: 122680, specId: 70 }],
  },
  BLESSING_OF_DAWN_TALENT: {
    id: 183416,
    name: 'Blessing of Dawn',
    icon: 'achievement_zone_valeofeternalblossoms',
    maxRanks: 1,
    entryIds: [115673],
    definitionIds: [{ id: 120685, specId: 70 }],
  },
  BLESSING_OF_DUSK_TALENT: {
    id: 1241945,
    name: 'Blessing of Dusk',
    icon: 'achievement_zone_newshadowmoonvalley',
    maxRanks: 1,
    entryIds: [128259],
    definitionIds: [{ id: 133066, specId: 70 }],
  },
  BLESSING_OF_FREEDOM_TALENT: {
    id: 1044,
    name: 'Blessing of Freedom',
    icon: 'spell_holy_sealofvalor',
    maxRanks: 1,
    entryIds: [128251],
    definitionIds: [{ id: 133058, specId: 70 }],
    manaCost: 3500,
  },
  BLESSING_OF_PROTECTION_TALENT: {
    id: 1022,
    name: 'Blessing of Protection',
    icon: 'spell_holy_sealofprotection',
    maxRanks: 1,
    entryIds: [102604],
    definitionIds: [{ id: 107609, specId: 70 }],
    manaCost: 7500,
  },
  BLESSING_OF_SACRIFICE_TALENT: {
    id: 6940,
    name: 'Blessing of Sacrifice',
    icon: 'spell_holy_sealofsacrifice',
    maxRanks: 1,
    entryIds: [102602],
    definitionIds: [{ id: 107607, specId: 70 }],
    manaCost: 3500,
  },
  BLESSING_OF_SPELLWARDING_TALENT: {
    id: 204018,
    name: 'Blessing of Spellwarding',
    icon: 'spell_holy_blessingofprotection',
    maxRanks: 1,
    entryIds: [111886],
    definitionIds: [{ id: 116891, specId: 66 }],
    manaCost: 7500,
  },
  BLESSING_OF_THE_FORGE_TALENT: {
    id: 433011,
    name: 'Blessing of the Forge',
    icon: 'inv_ability_lightsmithpaladin_sacredweapon',
    maxRanks: 1,
    entryIds: [117875],
    definitionIds: [{ id: 122887, specId: 66 }],
  },
  BLINDING_LIGHT_TALENT: {
    id: 115750,
    name: 'Blinding Light',
    icon: 'ability_paladin_blindinglight',
    maxRanks: 1,
    entryIds: [102584],
    definitionIds: [{ id: 107589, specId: 70 }],
    manaCost: 3000,
  },
  BONDS_OF_FELLOWSHIP_TALENT: {
    id: 432992,
    name: 'Bonds of Fellowship',
    icon: 'spell_holy_crusade',
    maxRanks: 1,
    entryIds: [117814],
    definitionIds: [{ id: 122826, specId: 70 }],
  },
  BORN_IN_SUNLIGHT_TALENT: {
    id: 1263920,
    name: 'Born in Sunlight',
    icon: 'spell_paladin_lightofdawn',
    maxRanks: 1,
    entryIds: [136007],
    definitionIds: [{ id: 140762, specId: 70 }],
  },
  BOUNDLESS_JUDGMENT_TALENT: {
    id: 405278,
    name: 'Boundless Judgment',
    icon: 'ability_paladin_judgementofthewise',
    maxRanks: 1,
    entryIds: [115021],
    definitionIds: [{ id: 120028, specId: 70 }],
  },
  BREAKING_DAWN_TALENT: {
    id: 387879,
    name: 'Breaking Dawn',
    icon: 'spell_holy_rune',
    maxRanks: 2,
    entryIds: [102567],
    definitionIds: [{ id: 107572, specId: 65 }],
  },
  BROUGHT_TO_LIGHT_TALENT: {
    id: 1265549,
    name: 'Brought to Light',
    icon: 'paladin_holy',
    maxRanks: 1,
    entryIds: [136486],
    definitionIds: [{ id: 141259, specId: 70 }],
  },
  BULWARK_OF_ORDER_TALENT: {
    id: 209389,
    name: 'Bulwark of Order',
    icon: 'spell_holy_pureofheart',
    maxRanks: 1,
    entryIds: [102468],
    definitionIds: [{ id: 107473, specId: 66 }],
  },
  BULWARK_OF_RIGHTEOUS_FURY_TALENT: {
    id: 386653,
    name: 'Bulwark of Righteous Fury',
    icon: 'spell_holy_sealofrighteousness',
    maxRanks: 1,
    entryIds: [102457],
    definitionIds: [{ id: 107462, specId: 66 }],
  },
  BURNING_CRUSADE_TALENT: {
    id: 403026,
    name: 'Burning Crusade',
    icon: 'spell_fire_sealoffire',
    maxRanks: 1,
    entryIds: [115024],
    definitionIds: [{ id: 120031, specId: 70 }],
  },
  BURN_TO_ASH_TALENT: {
    id: 446663,
    name: 'Burn to Ash',
    icon: 'spell_burningsoul',
    maxRanks: 1,
    entryIds: [114824],
    definitionIds: [{ id: 119831, specId: 70 }],
  },
  CALL_OF_THE_RIGHTEOUS_TALENT: {
    id: 1241511,
    name: 'Call of the Righteous',
    icon: 'ability_paladin_gaurdedbythelight',
    maxRanks: 2,
    entryIds: [102572],
    definitionIds: [{ id: 107577, specId: 65 }],
  },
  CAVALIER_TALENT: {
    id: 230332,
    name: 'Cavalier',
    icon: 'ability_paladin_divinesteed',
    maxRanks: 1,
    entryIds: [102592],
    definitionIds: [{ id: 107597, specId: 70 }],
  },
  CLEANSE_TOXINS_TALENT: {
    id: 213644,
    name: 'Cleanse Toxins',
    icon: 'spell_holy_renew',
    maxRanks: 1,
    entryIds: [102476],
    definitionIds: [{ id: 107481, specId: 70 }],
    manaCost: 25000,
  },
  COMMANDING_LIGHT_TALENT: {
    id: 387781,
    name: 'Commanding Light',
    icon: 'ability_paladin_beaconoflight',
    maxRanks: 1,
    entryIds: [102564],
    definitionIds: [{ id: 107569, specId: 65 }],
  },
  CONSECRATED_GROUND_TALENT: {
    id: 204054,
    name: 'Consecrated Ground',
    icon: 'ability_paladin_righteousvengeance',
    maxRanks: 1,
    entryIds: [102518],
    definitionIds: [{ id: 107523, specId: 70 }],
  },
  CONSECRATION_IN_FLAME_TALENT: {
    id: 379022,
    name: 'Consecration in Flame',
    icon: 'spell_fire_sealoffire',
    maxRanks: 2,
    entryIds: [102450],
    definitionIds: [{ id: 107449, specId: 66 }],
  },
  CRUSADERS_JUDGMENT_TALENT: {
    id: 204023,
    name: "Crusader's Judgment",
    icon: 'ability_paladin_enlightenedjudgements',
    maxRanks: 1,
    entryIds: [102600],
    definitionIds: [{ id: 107605, specId: 66 }],
  },
  CRUSADERS_MIGHT_TALENT: {
    id: 196926,
    name: "Crusader's Might",
    icon: 'ability_paladin_swiftretribution',
    maxRanks: 1,
    entryIds: [136574],
    definitionIds: [{ id: 141347, specId: 65 }],
  },
  CRUSADERS_RESOLVE_TALENT: {
    id: 380188,
    name: "Crusader's Resolve",
    icon: 'ability_priest_angelicbulwark',
    maxRanks: 1,
    entryIds: [102460],
    definitionIds: [{ id: 107465, specId: 66 }],
  },
  CRUSADE_TALENT: {
    id: 1253598,
    name: 'Crusade',
    icon: 'ability_paladin_sanctifiedwrath',
    maxRanks: 1,
    entryIds: [135565],
    definitionIds: [{ id: 140321, specId: 70 }],
  },
  CRUSADING_STRIKES_TALENT: {
    id: 404542,
    name: 'Crusading Strikes',
    icon: 'inv_sword_08',
    maxRanks: 1,
    entryIds: [136809],
    definitionIds: [{ id: 141572, specId: 70 }],
  },
  DAWNLIGHT_TALENT: {
    id: 431377,
    name: 'Dawnlight',
    icon: 'inv_ability_heraldofthesunpaladin_dawnlight',
    maxRanks: 1,
    entryIds: [117696],
    definitionIds: [{ id: 122708, specId: 70 }],
  },
  DIVINE_EXACTION_TALENT: {
    id: 1260429,
    name: 'Divine Exaction',
    icon: 'inv_ability_paladin_divinetoll',
    maxRanks: 1,
    entryIds: [136003],
    definitionIds: [{ id: 140758, specId: 70 }],
  },
  DIVINE_FAVOR_TALENT: {
    id: 1270916,
    name: 'Divine Favor',
    icon: 'spell_holy_heal',
    maxRanks: 1,
    entryIds: [102551],
    definitionIds: [{ id: 107556, specId: 65 }],
  },
  DIVINE_GLIMPSE_TALENT: {
    id: 387805,
    name: 'Divine Glimpse',
    icon: 'spell_holy_healingaura',
    maxRanks: 1,
    entryIds: [102570],
    definitionIds: [{ id: 107575, specId: 65 }],
  },
  DIVINE_GUIDANCE_TALENT: {
    id: 433106,
    name: 'Divine Guidance',
    icon: 'spell_holy_lightsgrace',
    maxRanks: 1,
    entryIds: [117884],
    definitionIds: [{ id: 122896, specId: 66 }],
  },
  DIVINE_HAMMER_TALENT: {
    id: 432929,
    name: 'Divine Hammer',
    icon: 'classicon_paladin',
    maxRanks: 1,
    entryIds: [136005],
    definitionIds: [{ id: 140760, specId: 70 }],
  },
  DIVINE_INSPIRATION_TALENT: {
    id: 432964,
    name: 'Divine Inspiration',
    icon: 'ability_priest_flashoflight',
    maxRanks: 1,
    entryIds: [117877],
    definitionIds: [{ id: 122889, specId: 66 }],
  },
  DIVINE_OVERLOAD_TALENT: {
    id: 1271077,
    name: 'Divine Overload',
    icon: 'spell_holy_surgeoflight',
    maxRanks: 1,
    entryIds: [102574],
    definitionIds: [{ id: 107579, specId: 65 }],
  },
  DIVINE_PURPOSE_RETRIBUTION_TALENT: {
    id: 408459,
    name: 'Divine Purpose',
    icon: 'spell_holy_divinepurpose',
    maxRanks: 1,
    entryIds: [128243],
    definitionIds: [{ id: 133050, specId: 70 }],
  },
  DIVINE_PURPOSE_SHARED_TALENT: {
    id: 223817,
    name: 'Divine Purpose',
    icon: 'spell_holy_divinepurpose',
    maxRanks: 1,
    entryIds: [128246, 128244],
    definitionIds: [
      { id: 133053, specId: 65 },
      { id: 133051, specId: 66 },
    ],
  },
  DIVINE_REACH_TALENT: {
    id: 469476,
    name: 'Divine Reach',
    icon: 'spell_holy_mindvision',
    maxRanks: 1,
    entryIds: [115447],
    definitionIds: [{ id: 120459, specId: 70 }],
  },
  DIVINE_RESONANCE_RETRIBUTION_TALENT: {
    id: 384027,
    name: 'Divine Resonance',
    icon: 'ability_mount_goatmountwhite',
    maxRanks: 1,
    entryIds: [115468],
    definitionIds: [{ id: 120480, specId: 70 }],
  },
  DIVINE_RESONANCE_SHARED_TALENT: {
    id: 386738,
    name: 'Divine Resonance',
    icon: 'ability_mount_goatmountwhite',
    maxRanks: 1,
    entryIds: [115466, 102443],
    definitionIds: [
      { id: 120478, specId: 65 },
      { id: 107448, specId: 66 },
    ],
  },
  DIVINE_REVELATIONS_TALENT: {
    id: 387808,
    name: 'Divine Revelations',
    icon: 'ability_paladin_infusionoflight',
    maxRanks: 1,
    entryIds: [102562],
    definitionIds: [{ id: 107567, specId: 65 }],
  },
  DIVINE_SPURS_TALENT: {
    id: 469409,
    name: 'Divine Spurs',
    icon: 'ability_mount_charger',
    maxRanks: 1,
    entryIds: [128253],
    definitionIds: [{ id: 133060, specId: 70 }],
  },
  DIVINE_STEED_TALENT: {
    id: 190784,
    name: 'Divine Steed',
    icon: 'ability_paladin_divinesteed',
    maxRanks: 1,
    entryIds: [102625],
    definitionIds: [{ id: 107630, specId: 70 }],
  },
  DIVINE_STORM_TALENT: {
    id: 53385,
    name: 'Divine Storm',
    icon: 'ability_paladin_divinestorm',
    maxRanks: 1,
    entryIds: [102499],
    definitionIds: [{ id: 107504, specId: 70 }],
    holyPowerCost: 3,
  },
  DIVINE_TOLL_TALENT: {
    id: 375576,
    name: 'Divine Toll',
    icon: 'inv_ability_paladin_divinetoll',
    maxRanks: 1,
    entryIds: [102465, 136496, 135564],
    definitionIds: [
      { id: 107470, specId: 65 },
      { id: 141269, specId: 66 },
      { id: 140320, specId: 70 },
    ],
    manaCost: 7500,
  },
  DIVINE_WRATH_TALENT: {
    id: 406872,
    name: 'Divine Wrath',
    icon: 'spell_holy_greaterblessingofkings',
    maxRanks: 2,
    entryIds: [115439],
    definitionIds: [{ id: 120451, specId: 70 }],
  },
  ECHOING_BLESSINGS_TALENT: {
    id: 387801,
    name: 'Echoing Blessings',
    icon: 'achievement_dungeon_heroic_gloryoftheraider',
    maxRanks: 1,
    entryIds: [115872],
    definitionIds: [{ id: 120884, specId: 65 }],
  },
  EMPYREAL_WARD_TALENT: {
    id: 387791,
    name: 'Empyreal Ward',
    icon: 'spell_holy_layonhands',
    maxRanks: 1,
    entryIds: [128255],
    definitionIds: [{ id: 133062, specId: 70 }],
  },
  EMPYREAN_AUTHORITY_TALENT: {
    id: 1246481,
    name: 'Empyrean Authority',
    icon: 'ability_paladin_empoweredsealsrighteous',
    maxRanks: 1,
    entryIds: [102466],
    definitionIds: [{ id: 107471, specId: 66 }],
  },
  EMPYREAN_LEGACY_HOLY_TALENT: {
    id: 1241358,
    name: 'Empyrean Legacy',
    icon: 'item_holyspark',
    maxRanks: 1,
    entryIds: [102576],
    definitionIds: [{ id: 107581, specId: 65 }],
  },
  EMPYREAN_LEGACY_RETRIBUTION_TALENT: {
    id: 387170,
    name: 'Empyrean Legacy',
    icon: 'item_holyspark',
    maxRanks: 1,
    entryIds: [115453],
    definitionIds: [{ id: 120465, specId: 70 }],
  },
  EMPYREAN_POWER_TALENT: {
    id: 326732,
    name: 'Empyrean Power',
    icon: 'ability_paladin_sheathoflight',
    maxRanks: 1,
    entryIds: [115051],
    definitionIds: [{ id: 120058, specId: 70 }],
  },
  ENDLESS_GLEAM_TALENT: {
    id: 1263787,
    name: 'Endless Gleam',
    icon: 'spell_paladin_inquisition',
    maxRanks: 1,
    entryIds: [136006],
    definitionIds: [{ id: 140761, specId: 70 }],
  },
  ENDLESS_WRATH_TALENT: {
    id: 432615,
    name: 'Endless Wrath',
    icon: 'spell_holy_divinepurpose',
    maxRanks: 1,
    entryIds: [117820],
    definitionIds: [{ id: 122832, specId: 70 }],
  },
  ETERNAL_FLAME_TALENT: {
    id: 156322,
    name: 'Eternal Flame',
    icon: 'inv_torch_thrown',
    maxRanks: 1,
    entryIds: [117692],
    definitionIds: [{ id: 122704, specId: 70 }],
    holyPowerCost: 3,
    manaCost: 25000,
  },
  EXECUTION_SENTENCE_TALENT: {
    id: 343527,
    name: 'Execution Sentence',
    icon: 'spell_paladin_executionsentence',
    maxRanks: 1,
    entryIds: [115435],
    definitionIds: [{ id: 120447, specId: 70 }],
  },
  EXPURGATION_TALENT: {
    id: 383344,
    name: 'Expurgation',
    icon: 'ability_paladin_bladeofjusticeblue',
    maxRanks: 1,
    entryIds: [114830],
    definitionIds: [{ id: 119837, specId: 70 }],
  },
  EXTRICATION_TALENT: {
    id: 461278,
    name: 'Extrication',
    icon: 'spell_holy_spiritualguidence',
    maxRanks: 1,
    entryIds: [102575],
    definitionIds: [{ id: 107580, specId: 65 }],
  },
  EYE_FOR_AN_EYE_TALENT: {
    id: 469309,
    name: 'Eye for an Eye',
    icon: 'spell_holy_eyeforaneye',
    maxRanks: 1,
    entryIds: [102620],
    definitionIds: [{ id: 107625, specId: 70 }],
  },
  FAITHS_ARMOR_TALENT: {
    id: 406101,
    name: "Faith's Armor",
    icon: 'inv_shield_1h_newplayer_a_01',
    maxRanks: 1,
    entryIds: [102464],
    definitionIds: [{ id: 107469, specId: 70 }],
  },
  FEAR_NO_EVIL_TALENT: {
    id: 1265541,
    name: 'Fear No Evil',
    icon: 'inv_bracer_plate_raidpaladin_r_01mythic',
    maxRanks: 1,
    entryIds: [136485],
    definitionIds: [{ id: 141258, specId: 70 }],
  },
  FERREN_MARCUSS_FERVOR_TALENT: {
    id: 378762,
    name: "Ferren Marcus's Fervor",
    icon: 'spell_holy_sealofwrath',
    maxRanks: 2,
    entryIds: [102446],
    definitionIds: [{ id: 107451, specId: 66 }],
  },
  FINAL_STAND_TALENT: {
    id: 204077,
    name: 'Final Stand',
    icon: 'spell_holy_crusade',
    maxRanks: 1,
    entryIds: [102473],
    definitionIds: [{ id: 107478, specId: 66 }],
  },
  FINAL_VERDICT_TALENT: {
    id: 383328,
    name: 'Final Verdict',
    icon: 'spell_paladin_templarsverdict',
    maxRanks: 1,
    entryIds: [102504],
    definitionIds: [{ id: 107509, specId: 70 }],
    holyPowerCost: 3,
  },
  FIST_OF_JUSTICE_TALENT: {
    id: 234299,
    name: 'Fist of Justice',
    icon: 'spell_holy_fistofjustice',
    maxRanks: 1,
    entryIds: [136487],
    definitionIds: [{ id: 141260, specId: 70 }],
  },
  FOCUSED_ENMITY_TALENT: {
    id: 378845,
    name: 'Focused Enmity',
    icon: 'ability_priest_flashoflight',
    maxRanks: 1,
    entryIds: [102435],
    definitionIds: [{ id: 107440, specId: 66 }],
  },
  FOREWARNING_TALENT: {
    id: 432804,
    name: 'Forewarning',
    icon: 'ability_paladin_gaurdedbythelight',
    maxRanks: 1,
    entryIds: [117876],
    definitionIds: [{ id: 122888, specId: 66 }],
  },
  GIFT_OF_THE_GOLDEN_VALKYR_TALENT: {
    id: 378279,
    name: "Gift of the Golden Val'kyr",
    icon: 'inv_valkiergoldpet',
    maxRanks: 1,
    entryIds: [102449],
    definitionIds: [{ id: 107454, specId: 66 }],
  },
  GLEAMING_RAYS_TALENT: {
    id: 431480,
    name: 'Gleaming Rays',
    icon: 'spell_priest_power_word',
    maxRanks: 1,
    entryIds: [117778],
    definitionIds: [{ id: 122790, specId: 70 }],
  },
  GLISTENING_RADIANCE_TALENT: {
    id: 1241805,
    name: 'Glistening Radiance',
    icon: 'spell_paladin_divinecircle',
    maxRanks: 1,
    entryIds: [102559],
    definitionIds: [{ id: 107564, specId: 65 }],
  },
  GLORIOUS_DAWN_TALENT: {
    id: 461246,
    name: 'Glorious Dawn',
    icon: 'ability_paladin_holyavenger',
    maxRanks: 1,
    entryIds: [115873],
    definitionIds: [{ id: 120885, specId: 65 }],
  },
  GLORY_OF_THE_VANGUARD_1_PROTECTION_TALENT: {
    id: 1267203,
    name: 'Glory of the Vanguard',
    icon: 'inv12_apextalent_paladin_gloryofthevanguard',
    maxRanks: 1,
    entryIds: [137022],
    definitionIds: [{ id: 141785, specId: 66 }],
  },
  GLORY_OF_THE_VANGUARD_2_PROTECTION_TALENT: {
    id: 1267211,
    name: 'Glory of the Vanguard',
    icon: 'inv12_apextalent_paladin_gloryofthevanguard',
    maxRanks: 2,
    entryIds: [137021],
    definitionIds: [{ id: 141784, specId: 66 }],
  },
  GLORY_OF_THE_VANGUARD_3_PROTECTION_TALENT: {
    id: 1267215,
    name: 'Glory of the Vanguard',
    icon: 'inv12_apextalent_paladin_gloryofthevanguard',
    maxRanks: 1,
    entryIds: [137020],
    definitionIds: [{ id: 141783, specId: 66 }],
  },
  GOLDEN_PATH_TALENT: {
    id: 377128,
    name: 'Golden Path',
    icon: 'ability_priest_cascade',
    maxRanks: 1,
    entryIds: [128252],
    definitionIds: [{ id: 133059, specId: 70 }],
  },
  GRAND_CRUSADER_TALENT: {
    id: 85043,
    name: 'Grand Crusader',
    icon: 'inv_helmet_74',
    maxRanks: 1,
    entryIds: [102453],
    definitionIds: [{ id: 107458, specId: 66 }],
  },
  GREATER_JUDGMENT_HOLY_TALENT: {
    id: 231644,
    name: 'Greater Judgment',
    icon: 'spell_holy_righteousfury',
    maxRanks: 1,
    entryIds: [114292],
    definitionIds: [{ id: 119297, specId: 65 }],
  },
  GREATER_JUDGMENT_SHARED_TALENT: {
    id: 231663,
    name: 'Greater Judgment',
    icon: 'spell_holy_righteousfury',
    maxRanks: 1,
    entryIds: [102590],
    definitionIds: [{ id: 107595, specId: 70 }],
  },
  GUARDIAN_OF_ANCIENT_KINGS_TALENT: {
    id: 86659,
    name: 'Guardian of Ancient Kings',
    icon: 'spell_holy_heroism',
    maxRanks: 1,
    entryIds: [102456],
    definitionIds: [{ id: 107461, specId: 66 }],
  },
  GUIDED_PRAYER_TALENT: {
    id: 404357,
    name: 'Guided Prayer',
    icon: 'ability_crown_of_the_heavens_icon',
    maxRanks: 1,
    entryIds: [136503],
    definitionIds: [{ id: 141276, specId: 70 }],
  },
  HAMMERFALL_TALENT: {
    id: 432463,
    name: 'Hammerfall',
    icon: 'ability_paladin_enlightenedjudgements',
    maxRanks: 1,
    entryIds: [117818],
    definitionIds: [{ id: 122830, specId: 70 }],
  },
  HAMMER_AND_ANVIL_TALENT: {
    id: 433718,
    name: 'Hammer and Anvil',
    icon: 'inv_10_blacksmithing_consumable_repairhammer_color1',
    maxRanks: 1,
    entryIds: [136001],
    definitionIds: [{ id: 140756, specId: 66 }],
  },
  HAMMER_OF_THE_RIGHTEOUS_TALENT: {
    id: 53595,
    name: 'Hammer of the Righteous',
    icon: 'ability_paladin_hammeroftherighteous',
    maxRanks: 1,
    entryIds: [102431],
    definitionIds: [{ id: 107436, specId: 66 }],
  },
  HAMMER_OF_WRATH_TALENT: {
    id: 1241288,
    name: 'Hammer of Wrath',
    icon: 'inv12_ability_paladin_hammerofwrath',
    maxRanks: 1,
    entryIds: [133481],
    definitionIds: [{ id: 138267, specId: 70 }],
  },
  HAND_OF_DIVINITY_TALENT: {
    id: 1242008,
    name: 'Hand of Divinity',
    icon: 'spell_holy_vindication',
    maxRanks: 1,
    entryIds: [133501],
    definitionIds: [{ id: 138287, specId: 65 }],
  },
  HAND_OF_THE_PROTECTOR_TALENT: {
    id: 315924,
    name: 'Hand of the Protector',
    icon: 'ability_paladin_blessedhands',
    maxRanks: 1,
    entryIds: [102438],
    definitionIds: [{ id: 107443, specId: 66 }],
  },
  HEALING_HANDS_TALENT: {
    id: 326734,
    name: 'Healing Hands',
    icon: 'ability_paladin_infusionoflight',
    maxRanks: 1,
    entryIds: [115481],
    definitionIds: [{ id: 120493, specId: 70 }],
  },
  HEART_OF_THE_CRUSADER_TALENT: {
    id: 406154,
    name: 'Heart of the Crusader',
    icon: 'spell_brokenheart',
    maxRanks: 2,
    entryIds: [115483],
    definitionIds: [{ id: 120495, specId: 70 }],
  },
  HIGHER_CALLING_TALENT: {
    id: 431687,
    name: 'Higher Calling',
    icon: 'ability_paladin_toweroflight',
    maxRanks: 1,
    entryIds: [117811],
    definitionIds: [{ id: 122823, specId: 70 }],
  },
  HIGHLORDS_WRATH_TALENT: {
    id: 404512,
    name: "Highlord's Wrath",
    icon: 'ability_paladin_judgementred',
    maxRanks: 1,
    entryIds: [102506],
    definitionIds: [{ id: 107511, specId: 70 }],
  },
  HOLY_AEGIS_TALENT: {
    id: 385515,
    name: 'Holy Aegis',
    icon: 'ability_paladin_touchedbylight',
    maxRanks: 1,
    entryIds: [102597],
    definitionIds: [{ id: 107602, specId: 70 }],
  },
  HOLY_ARMAMENTS_HOLY_TALENT: {
    id: 1289728,
    name: 'Holy Armaments',
    icon: 'inv_ability_lightsmithpaladin_holybulwark',
    maxRanks: 1,
    entryIds: [136795],
    definitionIds: [{ id: 141558, specId: 65 }],
  },
  HOLY_ARMAMENTS_PROTECTION_TALENT: {
    id: 432459,
    name: 'Holy Armaments',
    icon: 'inv_ability_lightsmithpaladin_holybulwark',
    maxRanks: 1,
    entryIds: [117882],
    definitionIds: [{ id: 122894, specId: 66 }],
  },
  HOLY_BLADE_TALENT: {
    id: 383342,
    name: 'Holy Blade',
    icon: 'ability_paladin_lightoftheprotector',
    maxRanks: 1,
    entryIds: [115022],
    definitionIds: [{ id: 120029, specId: 70 }],
  },
  HOLY_FLAMES_TALENT: {
    id: 406545,
    name: 'Holy Flames',
    icon: 'ability_warlock_inferno',
    maxRanks: 1,
    entryIds: [115438],
    definitionIds: [{ id: 120450, specId: 70 }],
  },
  HOLY_PRISM_TALENT: {
    id: 114165,
    name: 'Holy Prism',
    icon: 'spell_paladin_holyprism',
    maxRanks: 1,
    entryIds: [133480],
    definitionIds: [{ id: 138266, specId: 65 }],
    manaCost: 6500,
  },
  HOLY_REPRIEVE_TALENT: {
    id: 469445,
    name: 'Holy Reprieve',
    icon: 'spell_holy_sealofsalvation',
    maxRanks: 1,
    entryIds: [128256],
    definitionIds: [{ id: 133063, specId: 70 }],
  },
  HOLY_RITUAL_TALENT: {
    id: 199422,
    name: 'Holy Ritual',
    icon: 'inv_relics_libramoftruth',
    maxRanks: 1,
    entryIds: [128262],
    definitionIds: [{ id: 133069, specId: 70 }],
  },
  HOLY_SHOCK_TALENT: {
    id: 20473,
    name: 'Holy Shock',
    icon: 'spell_holy_searinglight',
    maxRanks: 1,
    entryIds: [102534],
    definitionIds: [{ id: 107539, specId: 65 }],
    manaCost: 5600,
  },
  ILLUMINE_TALENT: {
    id: 431423,
    name: 'Illumine',
    icon: 'spell_holy_divineillumination',
    maxRanks: 1,
    entryIds: [117695],
    definitionIds: [{ id: 122707, specId: 70 }],
  },
  IMBUED_INFUSIONS_TALENT: {
    id: 392961,
    name: 'Imbued Infusions',
    icon: 'ability_priest_flashoflight',
    maxRanks: 1,
    entryIds: [102536],
    definitionIds: [{ id: 107541, specId: 65 }],
  },
  IMBUED_SHIELD_TALENT: {
    id: 1276945,
    name: 'Imbued Shield',
    icon: 'inv_artifact_bulwarkoforder',
    maxRanks: 1,
    entryIds: [102463],
    definitionIds: [{ id: 107468, specId: 66 }],
  },
  IMPROVED_ARDENT_DEFENDER_TALENT: {
    id: 393114,
    name: 'Improved Ardent Defender',
    icon: 'spell_holy_ardentdefender',
    maxRanks: 1,
    entryIds: [111887],
    definitionIds: [{ id: 116892, specId: 66 }],
  },
  IMPROVED_BLADE_OF_JUSTICE_TALENT: {
    id: 403745,
    name: 'Improved Blade of Justice',
    icon: 'ability_paladin_bladeofjustice',
    maxRanks: 1,
    entryIds: [115023],
    definitionIds: [{ id: 120030, specId: 70 }],
  },
  IMPROVED_BLESSING_OF_PROTECTION_TALENT: {
    id: 384909,
    name: 'Improved Blessing of Protection',
    icon: 'spell_holy_sealofprotection',
    maxRanks: 1,
    entryIds: [102606],
    definitionIds: [{ id: 107611, specId: 70 }],
  },
  IMPROVED_CLEANSE_TALENT: {
    id: 393024,
    name: 'Improved Cleanse',
    icon: 'spell_holy_purify',
    maxRanks: 1,
    entryIds: [102477],
    definitionIds: [{ id: 107482, specId: 65 }],
  },
  IMPROVED_JUDGMENT_TALENT: {
    id: 405461,
    name: 'Improved Judgment',
    icon: 'spell_holy_righteousfury',
    maxRanks: 1,
    entryIds: [102505],
    definitionIds: [{ id: 107510, specId: 70 }],
  },
  INFLORESCENCE_OF_THE_SUNWELL_TALENT: {
    id: 392907,
    name: 'Inflorescence of the Sunwell',
    icon: 'spell_lfieblood',
    maxRanks: 1,
    entryIds: [102577],
    definitionIds: [{ id: 107582, specId: 65 }],
  },
  INFUSION_OF_LIGHT_TALENT: {
    id: 53576,
    name: 'Infusion of Light',
    icon: 'ability_paladin_infusionoflight',
    maxRanks: 1,
    entryIds: [102550],
    definitionIds: [{ id: 107555, specId: 65 }],
  },
  INSPIRED_GUARD_TALENT: {
    id: 469439,
    name: 'Inspired Guard',
    icon: 'spell_holy_divineprotection',
    maxRanks: 1,
    entryIds: [128260],
    definitionIds: [{ id: 133067, specId: 70 }],
  },
  INSTRUMENT_OF_THE_DIVINE_TALENT: {
    id: 1277162,
    name: 'Instrument of the Divine',
    icon: 'ability_priest_archangel',
    maxRanks: 1,
    entryIds: [102454],
    definitionIds: [{ id: 107459, specId: 66 }],
  },
  JUDGE_JURY_AND_EXECUTIONER_TALENT: {
    id: 406157,
    name: 'Judge, Jury and Executioner',
    icon: 'spell_holy_sealofblood',
    maxRanks: 1,
    entryIds: [102511],
    definitionIds: [{ id: 107516, specId: 70 }],
  },
  JUDGMENT_OF_JUSTICE_TALENT: {
    id: 403495,
    name: 'Judgment of Justice',
    icon: 'ability_paladin_judgementblue',
    maxRanks: 1,
    entryIds: [115440],
    definitionIds: [{ id: 120452, specId: 70 }],
  },
  JURISDICTION_TALENT: {
    id: 402971,
    name: 'Jurisdiction',
    icon: 'ability_paladin_longarmofthelaw',
    maxRanks: 1,
    entryIds: [102516],
    definitionIds: [{ id: 107521, specId: 70 }],
  },
  LAYING_DOWN_ARMS_TALENT: {
    id: 432866,
    name: 'Laying Down Arms',
    icon: 'ability_paladin_handoflight',
    maxRanks: 1,
    entryIds: [117885],
    definitionIds: [{ id: 122897, specId: 66 }],
  },
  LAY_ON_HANDS_TALENT: {
    id: 633,
    name: 'Lay on Hands',
    icon: 'spell_holy_layonhands',
    maxRanks: 1,
    entryIds: [102583],
    definitionIds: [{ id: 107588, specId: 70 }],
  },
  LEAD_THE_CHARGE_TALENT: {
    id: 469780,
    name: 'Lead the Charge',
    icon: 'inv_helm_plate_raidpaladin_r_01mythic',
    maxRanks: 1,
    entryIds: [128263],
    definitionIds: [{ id: 133070, specId: 70 }],
  },
  LIBERATION_TALENT: {
    id: 461287,
    name: 'Liberation',
    icon: 'ability_paladin_toweroflight',
    maxRanks: 1,
    entryIds: [126571],
    definitionIds: [{ id: 131398, specId: 65 }],
  },
  LIGHTBEARER_TALENT: {
    id: 469416,
    name: 'Lightbearer',
    icon: 'spell_paladin_clarityofpurpose',
    maxRanks: 1,
    entryIds: [128257],
    definitionIds: [{ id: 133064, specId: 70 }],
  },
  LIGHTFORGED_BLESSING_RETRIBUTION_TALENT: {
    id: 403479,
    name: 'Lightforged Blessing',
    icon: 'spell_holy_circleofrenewal',
    maxRanks: 1,
    entryIds: [115239],
    definitionIds: [{ id: 120251, specId: 70 }],
  },
  LIGHTFORGED_BLESSING_SHARED_TALENT: {
    id: 406468,
    name: 'Lightforged Blessing',
    icon: 'spell_holy_circleofrenewal',
    maxRanks: 1,
    entryIds: [128242, 128240],
    definitionIds: [
      { id: 133049, specId: 65 },
      { id: 133047, specId: 66 },
    ],
  },
  LIGHTS_CONVICTION_TALENT: {
    id: 414073,
    name: "Light's Conviction",
    icon: 'paladin_holy',
    maxRanks: 1,
    entryIds: [116376],
    definitionIds: [{ id: 121388, specId: 65 }],
  },
  LIGHTS_COUNTENANCE_TALENT: {
    id: 469325,
    name: "Light's Countenance",
    icon: 'inv_shoulder_raidpaladindragon_d_01',
    maxRanks: 1,
    entryIds: [128247],
    definitionIds: [{ id: 133054, specId: 70 }],
  },
  LIGHTS_DELIVERANCE_TALENT: {
    id: 425518,
    name: "Light's Deliverance",
    icon: 'inv_glove_plate_raidpaladinmythic_q_01',
    maxRanks: 1,
    entryIds: [117815],
    definitionIds: [{ id: 122827, specId: 70 }],
  },
  LIGHTS_GUIDANCE_TALENT: {
    id: 427445,
    name: "Light's Guidance",
    icon: 'ability_paladin_longarmofthelaw',
    maxRanks: 1,
    entryIds: [117813],
    definitionIds: [{ id: 122825, specId: 70 }],
  },
  LIGHTS_JUDICATOR_TALENT: {
    id: 1261525,
    name: "Light's Judicator",
    icon: 'ability_paladin_judgementofthepure',
    maxRanks: 1,
    entryIds: [136004],
    definitionIds: [{ id: 140759, specId: 70 }],
  },
  LIGHTS_PROTECTION_TALENT: {
    id: 461243,
    name: "Light's Protection",
    icon: 'spell_holy_absolution',
    maxRanks: 1,
    entryIds: [115874],
    definitionIds: [{ id: 120886, specId: 65 }],
  },
  LIGHTS_REVOCATION_TALENT: {
    id: 146956,
    name: "Light's Revocation",
    icon: 'spell_holy_divineshield',
    maxRanks: 1,
    entryIds: [102596],
    definitionIds: [{ id: 107601, specId: 70 }],
  },
  LIGHT_OF_DAWN_TALENT: {
    id: 85222,
    name: 'Light of Dawn',
    icon: 'spell_paladin_lightofdawn',
    maxRanks: 1,
    entryIds: [102545],
    definitionIds: [{ id: 107550, specId: 65 }],
    holyPowerCost: 3,
  },
  LIGHT_OF_JUSTICE_TALENT: {
    id: 404436,
    name: 'Light of Justice',
    icon: 'inv_offhand_1h_ulduarraid_d_01',
    maxRanks: 1,
    entryIds: [114828],
    definitionIds: [{ id: 119835, specId: 70 }],
  },
  LIGHT_OF_THE_MARTYR_TALENT: {
    id: 447985,
    name: 'Light of the Martyr',
    icon: 'ability_paladin_lightofthemartyr',
    maxRanks: 1,
    entryIds: [102540],
    definitionIds: [{ id: 107545, specId: 65 }],
  },
  LIGHT_OF_THE_TITANS_TALENT: {
    id: 378405,
    name: 'Light of the Titans',
    icon: 'spell_paladin_lightofdawn',
    maxRanks: 1,
    entryIds: [102472],
    definitionIds: [{ id: 107477, specId: 66 }],
  },
  LIGHT_WITHIN_1_RETRIBUTION_TALENT: {
    id: 1261113,
    name: 'Light Within',
    icon: 'inv12_apextalent_paladin_lightwithin',
    maxRanks: 1,
    entryIds: [137025],
    definitionIds: [{ id: 141788, specId: 70 }],
  },
  LIGHT_WITHIN_2_RETRIBUTION_TALENT: {
    id: 1261111,
    name: 'Light Within',
    icon: 'inv_ability_holyfire_buff',
    maxRanks: 2,
    entryIds: [137024],
    definitionIds: [{ id: 141787, specId: 70 }],
  },
  LIGHT_WITHIN_3_RETRIBUTION_TALENT: {
    id: 1261159,
    name: 'Light Within',
    icon: 'inv_ability_holyfire_buff',
    maxRanks: 1,
    entryIds: [137023],
    definitionIds: [{ id: 141786, specId: 70 }],
  },
  LINGERING_RADIANCE_TALENT: {
    id: 431407,
    name: 'Lingering Radiance',
    icon: 'spell_holy_mindvision',
    maxRanks: 1,
    entryIds: [117779],
    definitionIds: [{ id: 122791, specId: 70 }],
  },
  LUMINOSITY_TALENT: {
    id: 431402,
    name: 'Luminosity',
    icon: 'inv_qirajidol_sun',
    maxRanks: 1,
    entryIds: [117677],
    definitionIds: [{ id: 122689, specId: 70 }],
  },
  MASTERWORK_TALENT: {
    id: 1271387,
    name: 'Masterwork',
    icon: 'inv_mace_1h_blacksmithing_b_01_black',
    maxRanks: 1,
    entryIds: [136000],
    definitionIds: [{ id: 140755, specId: 66 }],
  },
  MOMENT_OF_COMPASSION_TALENT: {
    id: 387786,
    name: 'Moment of Compassion',
    icon: 'spell_holy_flashheal',
    maxRanks: 1,
    entryIds: [102553],
    definitionIds: [{ id: 107558, specId: 65 }],
  },
  MORNING_STAR_TALENT: {
    id: 431482,
    name: 'Morning Star',
    icon: 'spell_holy_persecution',
    maxRanks: 1,
    entryIds: [117670],
    definitionIds: [{ id: 122682, specId: 70 }],
  },
  OBDURACY_TALENT: {
    id: 385427,
    name: 'Obduracy',
    icon: 'ability_paladin_speedoflight',
    maxRanks: 2,
    entryIds: [102622],
    definitionIds: [{ id: 107627, specId: 70 }],
  },
  OVERFLOWING_LIGHT_TALENT: {
    id: 461244,
    name: 'Overflowing Light',
    icon: 'spell_holy_holyguidance',
    maxRanks: 1,
    entryIds: [102535],
    definitionIds: [{ id: 107540, specId: 65 }],
  },
  PILLARS_OF_LIGHT_TALENT: {
    id: 1232616,
    name: 'Pillars of Light',
    icon: 'inv_helm_plate_raidpaladindragon_d_01',
    maxRanks: 1,
    entryIds: [102563],
    definitionIds: [{ id: 107568, specId: 65 }],
  },
  PROTECTION_OF_TYR_TALENT: {
    id: 200430,
    name: 'Protection of Tyr',
    icon: 'spell_holy_auramastery',
    maxRanks: 1,
    entryIds: [102546],
    definitionIds: [{ id: 107551, specId: 65 }],
  },
  PUNISHMENT_TALENT: {
    id: 403530,
    name: 'Punishment',
    icon: 'spell_holy_rebuke',
    maxRanks: 1,
    entryIds: [115444, 136592],
    definitionIds: [
      { id: 120456, specId: 66 },
      { id: 141365, specId: 70 },
    ],
  },
  QUICKENED_INVOCATION_TALENT: {
    id: 379391,
    name: 'Quickened Invocation',
    icon: 'spell_holy_pureofheart',
    maxRanks: 1,
    entryIds: [115465, 115168, 115467],
    definitionIds: [
      { id: 120477, specId: 65 },
      { id: 120175, specId: 66 },
      { id: 120479, specId: 70 },
    ],
  },
  RADIANT_GLORY_TALENT: {
    id: 458359,
    name: 'Radiant Glory',
    icon: 'achievement_dungeon_gloryoftheraider',
    maxRanks: 1,
    entryIds: [102525],
    definitionIds: [{ id: 107530, specId: 70 }],
  },
  REBUKE_TALENT: {
    id: 96231,
    name: 'Rebuke',
    icon: 'spell_holy_rebuke',
    maxRanks: 1,
    entryIds: [102591, 136594],
    definitionIds: [
      { id: 107596, specId: 66 },
      { id: 141367, specId: 70 },
    ],
  },
  RECLAMATION_TALENT: {
    id: 415364,
    name: 'Reclamation',
    icon: 'ability_paladin_longarmofthelaw',
    maxRanks: 1,
    entryIds: [102537],
    definitionIds: [{ id: 107542, specId: 65 }],
  },
  RECOMPENSE_TALENT: {
    id: 384914,
    name: 'Recompense',
    icon: 'ability_racial_foregedinflames',
    maxRanks: 1,
    entryIds: [102594],
    definitionIds: [{ id: 107599, specId: 70 }],
  },
  REDOUBT_TALENT: {
    id: 280373,
    name: 'Redoubt',
    icon: 'ability_warrior_shieldguard',
    maxRanks: 1,
    entryIds: [102462],
    definitionIds: [{ id: 107467, specId: 66 }],
  },
  REFINING_FIRE_TALENT: {
    id: 469883,
    name: 'Refining Fire',
    icon: 'inv_everburningignition_yellow',
    maxRanks: 1,
    entryIds: [102452],
    definitionIds: [{ id: 107457, specId: 66 }],
  },
  REFLECTION_OF_RADIANCE_TALENT: {
    id: 1271466,
    name: 'Reflection of Radiance',
    icon: 'inv_enchanting_70_pet_torch',
    maxRanks: 1,
    entryIds: [117887],
    definitionIds: [{ id: 122899, specId: 66 }],
  },
  RELENTLESS_INQUISITOR_TALENT: {
    id: 383388,
    name: 'Relentless Inquisitor',
    icon: 'spell_holy_mindvision',
    maxRanks: 1,
    entryIds: [102475],
    definitionIds: [{ id: 107480, specId: 66 }],
  },
  RESOUNDING_STRIKE_TALENT: {
    id: 1271553,
    name: 'Resounding Strike',
    icon: 'inv_11_0_arathordungeon_bell_color1',
    maxRanks: 1,
    entryIds: [136002],
    definitionIds: [{ id: 140757, specId: 66 }],
  },
  RESPLENDENT_LIGHT_TALENT: {
    id: 392902,
    name: 'Resplendent Light',
    icon: 'ability_priest_voidshift',
    maxRanks: 1,
    entryIds: [102552],
    definitionIds: [{ id: 107557, specId: 65 }],
  },
  RIGHTEOUS_CAUSE_TALENT: {
    id: 402912,
    name: 'Righteous Cause',
    icon: 'inv_sword_133',
    maxRanks: 1,
    entryIds: [102494],
    definitionIds: [{ id: 107499, specId: 70 }],
  },
  RIGHTEOUS_JUDGMENT_TALENT: {
    id: 414113,
    name: 'Righteous Judgment',
    icon: 'ability_priest_holybolts01',
    maxRanks: 1,
    entryIds: [115875],
    definitionIds: [{ id: 120887, specId: 65 }],
  },
  RIGHTEOUS_PROTECTION_TALENT: {
    id: 469321,
    name: 'Righteous Protection',
    icon: 'spell_holy_blessingofprotection',
    maxRanks: 1,
    entryIds: [128248],
    definitionIds: [{ id: 133055, specId: 70 }],
  },
  RIGHTEOUS_PROTECTOR_TALENT: {
    id: 204074,
    name: 'Righteous Protector',
    icon: 'ability_paladin_shieldofthetemplar',
    maxRanks: 1,
    entryIds: [102440],
    definitionIds: [{ id: 107445, specId: 66 }],
  },
  RINGING_OF_THE_HEAVENS_TALENT: {
    id: 1241542,
    name: 'Ringing of the Heavens',
    icon: 'paladin_protection',
    maxRanks: 1,
    entryIds: [133479],
    definitionIds: [{ id: 138265, specId: 65 }],
  },
  RISING_SUNLIGHT_TALENT: {
    id: 1277651,
    name: 'Rising Sunlight',
    icon: 'spell_priest_divinestar_holy',
    maxRanks: 1,
    entryIds: [102581],
    definitionIds: [{ id: 107586, specId: 65 }],
  },
  RITE_OF_ADJURATION_TALENT: {
    id: 433583,
    name: 'Rite of Adjuration',
    icon: 'inv_inscription_armorscroll02',
    maxRanks: 1,
    entryIds: [117880],
    definitionIds: [{ id: 122892, specId: 66 }],
  },
  RITE_OF_SANCTIFICATION_TALENT: {
    id: 433568,
    name: 'Rite of Sanctification',
    icon: 'inv_inscription_weaponscroll01',
    maxRanks: 1,
    entryIds: [117881],
    definitionIds: [{ id: 122893, specId: 66 }],
  },
  RUSH_OF_LIGHT_TALENT: {
    id: 407067,
    name: 'Rush of Light',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 1,
    entryIds: [115475],
    definitionIds: [{ id: 120487, specId: 70 }],
  },
  SACRED_STRENGTH_TALENT: {
    id: 469337,
    name: 'Sacred Strength',
    icon: 'spell_holy_righteousnessaura',
    maxRanks: 1,
    entryIds: [115489, 115490, 102608],
    definitionIds: [
      { id: 120501, specId: 65 },
      { id: 120502, specId: 66 },
      { id: 107613, specId: 70 },
    ],
  },
  SACRIFICE_OF_THE_JUST_TALENT: {
    id: 384820,
    name: 'Sacrifice of the Just',
    icon: 'spell_holy_sealofsacrifice',
    maxRanks: 1,
    entryIds: [102595],
    definitionIds: [{ id: 107600, specId: 70 }],
  },
  SACROSANCT_CRUSADE_TALENT: {
    id: 431730,
    name: 'Sacrosanct Crusade',
    icon: 'inv_plate_raidpaladinprimalist_d_01_cape',
    maxRanks: 1,
    entryIds: [117812],
    definitionIds: [{ id: 122824, specId: 70 }],
  },
  SANCTIFICATION_TALENT: {
    id: 432977,
    name: 'Sanctification',
    icon: 'ability_paladin_blessedhands',
    maxRanks: 1,
    entryIds: [117819],
    definitionIds: [{ id: 122831, specId: 70 }],
  },
  SANCTIFIED_PLATES_TALENT: {
    id: 402964,
    name: 'Sanctified Plates',
    icon: 'inv_chest_plate_raidpaladin_s_01',
    maxRanks: 2,
    entryIds: [115034],
    definitionIds: [{ id: 120041, specId: 70 }],
  },
  SANCTIFIED_WRATH_TALENT: {
    id: 53376,
    name: 'Sanctified Wrath',
    icon: 'ability_paladin_judgementsofthejust',
    maxRanks: 1,
    entryIds: [102578, 128278],
    definitionIds: [
      { id: 107583, specId: 65 },
      { id: 133085, specId: 66 },
    ],
  },
  SANCTIFY_TALENT: {
    id: 382536,
    name: 'Sanctify',
    icon: 'achievement_zone_firelands',
    maxRanks: 1,
    entryIds: [115488],
    definitionIds: [{ id: 120500, specId: 70 }],
  },
  SANCTUARY_TALENT: {
    id: 379021,
    name: 'Sanctuary',
    icon: 'spell_holy_innerfire',
    maxRanks: 1,
    entryIds: [102436],
    definitionIds: [{ id: 107441, specId: 66 }],
  },
  SAVED_BY_THE_LIGHT_TALENT: {
    id: 157047,
    name: 'Saved by the Light',
    icon: 'ability_paladin_savedbythelight',
    maxRanks: 1,
    entryIds: [102557],
    definitionIds: [{ id: 107562, specId: 65 }],
  },
  SEAL_OF_CHARITY_TALENT: {
    id: 384815,
    name: 'Seal of Charity',
    icon: 'spell_priest_power_word',
    maxRanks: 1,
    entryIds: [102467],
    definitionIds: [{ id: 107472, specId: 66 }],
  },
  SEAL_OF_MIGHT_TALENT: {
    id: 385450,
    name: 'Seal of Might',
    icon: 'spell_holy_sealofwrath',
    maxRanks: 2,
    entryIds: [102612],
    definitionIds: [{ id: 107617, specId: 70 }],
  },
  SEAL_OF_REPRISAL_TALENT: {
    id: 377053,
    name: 'Seal of Reprisal',
    icon: 'spell_holy_sealoffury',
    maxRanks: 1,
    entryIds: [102621],
    definitionIds: [{ id: 107626, specId: 66 }],
  },
  SEAL_OF_THE_TEMPLAR_TALENT: {
    id: 1263252,
    name: 'Seal of the Templar',
    icon: 'spell_paladin_templarsverdict',
    maxRanks: 1,
    entryIds: [136184],
    definitionIds: [{ id: 140957, specId: 70 }],
  },
  SEARING_SUNLIGHT_TALENT: {
    id: 1244070,
    name: 'Searing Sunlight',
    icon: 'ability_essence_reapingflames',
    maxRanks: 1,
    entryIds: [102470],
    definitionIds: [{ id: 107475, specId: 66 }],
  },
  SECOND_SUNRISE_TALENT: {
    id: 431474,
    name: 'Second Sunrise',
    icon: 'ability_priest_halo',
    maxRanks: 1,
    entryIds: [117683],
    definitionIds: [{ id: 122695, specId: 70 }],
  },
  SEEK_DELIVERANCE_TALENT: {
    id: 1271016,
    name: 'Seek Deliverance',
    icon: 'spell_holy_blessedresillience',
    maxRanks: 1,
    entryIds: [102580],
    definitionIds: [{ id: 107585, specId: 65 }],
  },
  SEETHING_FLAMES_TALENT: {
    id: 405355,
    name: 'Seething Flames',
    icon: 'ability_mage_flamecannon',
    maxRanks: 1,
    entryIds: [115043],
    definitionIds: [{ id: 120050, specId: 70 }],
  },
  SELFLESS_HEALER_TALENT: {
    id: 469434,
    name: 'Selfless Healer',
    icon: 'ability_paladin_gaurdedbythelight',
    maxRanks: 1,
    entryIds: [128309],
    definitionIds: [{ id: 133116, specId: 70 }],
  },
  SENTINEL_TALENT: {
    id: 389539,
    name: 'Sentinel',
    icon: 'spell_holy_holynova',
    maxRanks: 1,
    entryIds: [102447],
    definitionIds: [{ id: 107452, specId: 66 }],
  },
  SERAPHIC_BARRIER_TALENT: {
    id: 1241714,
    name: 'Seraphic Barrier',
    icon: 'ability_paladin_protectoroftheinnocent',
    maxRanks: 1,
    entryIds: [102579],
    definitionIds: [{ id: 107584, specId: 65 }],
  },
  SHAKE_THE_HEAVENS_TALENT: {
    id: 431533,
    name: 'Shake the Heavens',
    icon: 'ability_priest_holybolts01',
    maxRanks: 1,
    entryIds: [117823],
    definitionIds: [{ id: 122835, specId: 70 }],
  },
  SHARED_RESOLVE_TALENT: {
    id: 432821,
    name: 'Shared Resolve',
    icon: 'spell_holy_devotionaura',
    maxRanks: 1,
    entryIds: [117886],
    definitionIds: [{ id: 122898, specId: 66 }],
  },
  SHIELD_OF_VENGEANCE_TALENT: {
    id: 1261562,
    name: 'Shield of Vengeance',
    icon: 'ability_paladin_shieldofthetemplar',
    maxRanks: 1,
    entryIds: [136127],
    definitionIds: [{ id: 140882, specId: 70 }],
  },
  SHINING_LIGHT_TALENT: {
    id: 321136,
    name: 'Shining Light',
    icon: 'ability_paladin_toweroflight',
    maxRanks: 1,
    entryIds: [102455],
    definitionIds: [{ id: 107460, specId: 66 }],
  },
  SHINING_RIGHTEOUSNESS_TALENT: {
    id: 414443,
    name: 'Shining Righteousness',
    icon: 'spell_holy_holynova',
    maxRanks: 1,
    entryIds: [102541],
    definitionIds: [{ id: 107546, specId: 65 }],
  },
  SOARING_SHIELD_TALENT: {
    id: 378457,
    name: 'Soaring Shield',
    icon: 'spell_burningbladeshaman_lavaslash',
    maxRanks: 1,
    entryIds: [102434],
    definitionIds: [{ id: 107439, specId: 66 }],
  },
  SOLACE_TALENT: {
    id: 1245891,
    name: 'Solace',
    icon: 'spell_holy_prayerofmendingtga',
    maxRanks: 1,
    entryIds: [102451],
    definitionIds: [{ id: 107456, specId: 66 }],
  },
  SOLAR_GRACE_TALENT: {
    id: 431404,
    name: 'Solar Grace',
    icon: 'ability_malkorok_blightofyshaarj_yellow',
    maxRanks: 1,
    entryIds: [136008],
    definitionIds: [{ id: 140763, specId: 70 }],
  },
  SOLIDARITY_TALENT: {
    id: 432802,
    name: 'Solidarity',
    icon: 'spell_holy_heroism',
    maxRanks: 1,
    entryIds: [117873],
    definitionIds: [{ id: 122885, specId: 66 }],
  },
  STAND_AGAINST_EVIL_TALENT: {
    id: 469317,
    name: 'Stand Against Evil',
    icon: 'spell_holy_excorcism',
    maxRanks: 1,
    entryIds: [128249],
    definitionIds: [{ id: 133056, specId: 70 }],
  },
  STEED_OF_LIBERTY_TALENT: {
    id: 469304,
    name: 'Steed of Liberty',
    icon: 'spell_holy_crusaderaura',
    maxRanks: 1,
    entryIds: [102624],
    definitionIds: [{ id: 107629, specId: 70 }],
  },
  STOICISM_TALENT: {
    id: 469316,
    name: 'Stoicism',
    icon: 'spell_magic_magearmor',
    maxRanks: 1,
    entryIds: [128258],
    definitionIds: [{ id: 133065, specId: 70 }],
  },
  STRENGTH_IN_ADVERSITY_TALENT: {
    id: 393071,
    name: 'Strength in Adversity',
    icon: 'spell_holy_weaponmastery',
    maxRanks: 1,
    entryIds: [102461],
    definitionIds: [{ id: 107466, specId: 66 }],
  },
  SUNS_AVATAR_TALENT: {
    id: 431425,
    name: "Sun's Avatar",
    icon: 'ability_paladin_holyavenger',
    maxRanks: 1,
    entryIds: [117702],
    definitionIds: [{ id: 122714, specId: 70 }],
  },
  SUN_SEAR_TALENT: {
    id: 431413,
    name: 'Sun Sear',
    icon: 'spell_priest_burningwill',
    maxRanks: 1,
    entryIds: [117669],
    definitionIds: [{ id: 122681, specId: 70 }],
  },
  SWEEPING_VERDICT_TALENT: {
    id: 1246488,
    name: 'Sweeping Verdict',
    icon: 'spell_paladin_lightshammer',
    maxRanks: 1,
    entryIds: [102474],
    definitionIds: [{ id: 107479, specId: 66 }],
  },
  SWIFT_JUSTICE_TALENT: {
    id: 383228,
    name: 'Swift Justice',
    icon: 'ability_paladin_judgementofthepure',
    maxRanks: 1,
    entryIds: [102491],
    definitionIds: [{ id: 107496, specId: 70 }],
  },
  TEMPERED_IN_BATTLE_TALENT: {
    id: 469701,
    name: 'Tempered in Battle',
    icon: 'inv_everburningforge_yellow',
    maxRanks: 1,
    entryIds: [117878],
    definitionIds: [{ id: 122890, specId: 66 }],
  },
  TEMPEST_OF_THE_LIGHTBRINGER_TALENT: {
    id: 383396,
    name: 'Tempest of the Lightbringer',
    icon: 'ability_malkorok_blightofyshaarj_yellow',
    maxRanks: 1,
    entryIds: [115452],
    definitionIds: [{ id: 120464, specId: 70 }],
  },
  TEMPLAR_STRIKES_TALENT: {
    id: 406646,
    name: 'Templar Strikes',
    icon: 'inv_sword_2h_artifactashbringer_d_01',
    maxRanks: 1,
    entryIds: [115473],
    definitionIds: [{ id: 120485, specId: 70 }],
  },
  TIRIONS_DEVOTION_HOLY_TALENT: {
    id: 414720,
    name: "Tirion's Devotion",
    icon: 'spell_holy_revivechampion',
    maxRanks: 1,
    entryIds: [102556],
    definitionIds: [{ id: 107561, specId: 65 }],
  },
  TIRIONS_DEVOTION_PROTECTION_TALENT: {
    id: 392928,
    name: "Tirion's Devotion",
    icon: 'spell_holy_revivechampion',
    maxRanks: 1,
    entryIds: [125873],
    definitionIds: [{ id: 130704, specId: 66 }],
  },
  TRUTH_PREVAILS_TALENT: {
    id: 461273,
    name: 'Truth Prevails',
    icon: 'ability_paladin_artofwar',
    maxRanks: 1,
    entryIds: [133407],
    definitionIds: [{ id: 138193, specId: 65 }],
  },
  TURN_EVIL_TALENT: {
    id: 10326,
    name: 'Turn Evil',
    icon: 'ability_paladin_turnevil',
    maxRanks: 1,
    entryIds: [102623],
    definitionIds: [{ id: 107628, specId: 70 }],
    manaCost: 5250,
  },
  TYRS_DELIVERANCE_TALENT: {
    id: 1241275,
    name: "Tyr's Deliverance",
    icon: 'inv_mace_2h_artifactsilverhand_d_01',
    maxRanks: 1,
    entryIds: [102573],
    definitionIds: [{ id: 107578, specId: 65 }],
  },
  TYRS_ENFORCER_TALENT: {
    id: 378285,
    name: "Tyr's Enforcer",
    icon: 'spell_holy_persecution',
    maxRanks: 2,
    entryIds: [102437],
    definitionIds: [{ id: 107442, specId: 66 }],
  },
  UNBOUND_FREEDOM_TALENT: {
    id: 305394,
    name: 'Unbound Freedom',
    icon: 'spell_holy_sealofvalor',
    maxRanks: 1,
    entryIds: [131438, 115479, 115454],
    definitionIds: [
      { id: 136239, specId: 65 },
      { id: 120491, specId: 66 },
      { id: 120466, specId: 70 },
    ],
  },
  UNBREAKABLE_SPIRIT_TALENT: {
    id: 114154,
    name: 'Unbreakable Spirit',
    icon: 'spell_holy_holyguidance',
    maxRanks: 1,
    entryIds: [102603],
    definitionIds: [{ id: 107608, specId: 70 }],
  },
  UNDISPUTED_RULING_TALENT: {
    id: 432626,
    name: 'Undisputed Ruling',
    icon: 'spell_holy_righteousfury',
    maxRanks: 1,
    entryIds: [117822],
    definitionIds: [{ id: 122834, specId: 70 }],
  },
  UNDYING_EMBERS_TALENT: {
    id: 1244019,
    name: 'Undying Embers',
    icon: 'inv_achievement_dungeon_darkflamecleft',
    maxRanks: 1,
    entryIds: [102459],
    definitionIds: [{ id: 107464, specId: 66 }],
  },
  UNENDING_LIGHT_TALENT: {
    id: 1271221,
    name: 'Unending Light',
    icon: 'spell_holy_holybolt',
    maxRanks: 1,
    entryIds: [102558],
    definitionIds: [{ id: 107563, specId: 65 }],
  },
  UNRELENTING_CHARGER_TALENT: {
    id: 432990,
    name: 'Unrelenting Charger',
    icon: 'ability_mount_mawhorsespikes_yellow',
    maxRanks: 1,
    entryIds: [117858],
    definitionIds: [{ id: 122870, specId: 70 }],
  },
  UNWAVERING_SPIRIT_TALENT: {
    id: 392911,
    name: 'Unwavering Spirit',
    icon: 'spell_holy_fanaticism',
    maxRanks: 1,
    entryIds: [102547],
    definitionIds: [{ id: 107552, specId: 65 }],
  },
  UTHERS_COUNSEL_TALENT: {
    id: 378425,
    name: "Uther's Counsel",
    icon: 'spell_holy_greaterblessingofsalvation',
    maxRanks: 1,
    entryIds: [102469],
    definitionIds: [{ id: 107474, specId: 66 }],
  },
  VALIANCE_TALENT: {
    id: 432919,
    name: 'Valiance',
    icon: 'inv_mace_47',
    maxRanks: 1,
    entryIds: [117874],
    definitionIds: [{ id: 122886, specId: 66 }],
  },
  VALIANT_CRUSADE_TALENT: {
    id: 1245979,
    name: 'Valiant Crusade',
    icon: 'ability_mount_alliancepvpmount',
    maxRanks: 1,
    entryIds: [102439],
    definitionIds: [{ id: 107444, specId: 66 }],
  },
  VENERATION_TALENT: {
    id: 392938,
    name: 'Veneration',
    icon: 'ability_crown_of_the_heavens_icon',
    maxRanks: 1,
    entryIds: [102565],
    definitionIds: [{ id: 107570, specId: 65 }],
  },
  VENGEFUL_WRATH_TALENT: {
    id: 1241958,
    name: 'Vengeful Wrath',
    icon: 'spell_paladin_hammerofwrath',
    maxRanks: 2,
    entryIds: [128241],
    definitionIds: [{ id: 133048, specId: 70 }],
  },
  VISION_OF_SANCTITY_TALENT: {
    id: 1245354,
    name: 'Vision of Sanctity',
    icon: 'ability_racial_orbitalstrike',
    maxRanks: 1,
    entryIds: [102432],
    definitionIds: [{ id: 107437, specId: 66 }],
  },
  WAKE_OF_ASHES_TALENT: {
    id: 255937,
    name: 'Wake of Ashes',
    icon: 'inv_sword_2h_artifactashbringerfire_d_03',
    maxRanks: 1,
    entryIds: [102497],
    definitionIds: [{ id: 107502, specId: 70 }],
  },
  WALK_INTO_LIGHT_TALENT: {
    id: 1263782,
    name: 'Walk Into Light',
    icon: 'ability_paladin_sheathoflight',
    maxRanks: 1,
    entryIds: [117691],
    definitionIds: [{ id: 122703, specId: 70 }],
  },
  WILL_OF_THE_DAWN_TALENT: {
    id: 431406,
    name: 'Will of the Dawn',
    icon: 'spell_holy_divineprovidence',
    maxRanks: 1,
    entryIds: [117777],
    definitionIds: [{ id: 122789, specId: 70 }],
  },
  WORTHY_SACRIFICE_TALENT: {
    id: 469279,
    name: 'Worthy Sacrifice',
    icon: 'ability_paladin_handoflight',
    maxRanks: 1,
    entryIds: [128261],
    definitionIds: [{ id: 133068, specId: 70 }],
  },
  WRATHFUL_DESCENT_TALENT: {
    id: 431551,
    name: 'Wrathful Descent',
    icon: 'ability_paladin_intercession',
    maxRanks: 1,
    entryIds: [117810],
    definitionIds: [{ id: 122822, specId: 70 }],
  },
  WRENCH_EVIL_TALENT: {
    id: 460720,
    name: 'Wrench Evil',
    icon: 'ability_paladin_turnevil',
    maxRanks: 1,
    entryIds: [128250],
    definitionIds: [{ id: 133057, specId: 70 }],
  },
  ZEALOTS_FERVOR_TALENT: {
    id: 403509,
    name: "Zealot's Fervor",
    icon: 'spell_holy_weaponmastery',
    maxRanks: 2,
    entryIds: [115165],
    definitionIds: [{ id: 120172, specId: 70 }],
  },
  ZEALOTS_PARAGON_TALENT: {
    id: 391142,
    name: "Zealot's Paragon",
    icon: 'ability_paladin_conviction',
    maxRanks: 2,
    entryIds: [102433],
    definitionIds: [{ id: 107438, specId: 66 }],
  },
  ZEALOUS_VINDICATION_TALENT: {
    id: 431463,
    name: 'Zealous Vindication',
    icon: 'spell_holy_surgeoflight',
    maxRanks: 1,
    entryIds: [117816],
    definitionIds: [{ id: 122828, specId: 70 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_PALADIN };
